"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeNEWS = function CategoryCodeNEWS(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeNEWS"), _react.default.createElement("g", null, _react.default.createElement("rect", {
    x: "9.615",
    y: "5.16",
    width: "3.229",
    height: "0.811",
    rx: "0.406",
    ry: "0.406"
  }), _react.default.createElement("rect", {
    x: "9.615",
    y: "8.406",
    width: "3.229",
    height: "0.811",
    rx: "0.406",
    ry: "0.406"
  }), _react.default.createElement("rect", {
    x: "9.615",
    y: "6.783",
    width: "3.229",
    height: "0.811",
    rx: "0.406",
    ry: "0.406"
  }), _react.default.createElement("rect", {
    x: "9.615",
    y: "10.028",
    width: "3.229",
    height: "0.811",
    rx: "0.406",
    ry: "0.406"
  }), _react.default.createElement("path", {
    d: "M14.055,3.538H3.56a.4.4,0,0,0-.4.4v.407H1.945a.4.4,0,0,0-.4.4v6.492a1.209,1.209,0,0,0,1.211,1.217H13.247a1.209,1.209,0,0,0,1.211-1.217v-7.3A.4.4,0,0,0,14.055,3.538Zm-10.9,7.707a.389.389,0,0,1-.12.285.393.393,0,0,1-.567,0,.389.389,0,0,1-.12-.285V5.564a.4.4,0,1,1,.807,0Zm10.5-6.492v6.9H3.964v-7.3h9.687Z"
  }), _react.default.createElement("path", {
    d: "M8.338,5.16h-3.1a.47.47,0,0,0-.47.47V8.747a.469.469,0,0,0,.47.47h3.1a.469.469,0,0,0,.469-.47V5.63A.47.47,0,0,0,8.338,5.16ZM8.012,8.406H5.578V5.972H8.012Z"
  }), _react.default.createElement("rect", {
    x: "4.771",
    y: "10.028",
    width: "4.036",
    height: "0.811",
    rx: "0.406",
    ry: "0.406"
  }))));
};

var _default = CategoryCodeNEWS;
exports.default = _default;